import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Box,
  Typography,
  TextField,
  Button,
  Alert,
} from "@mui/material";
import { imagenes } from "../../helpers/imagenes";
import { ErrorOutline } from "@mui/icons-material";
import { login as loginF } from "../../helpers/auth";

export const LoginPage = ({ isLogged }) => {
  // Si el usuario ya está logueado, lo redireccionamos a la página de inicio
  if (isLogged) {
    window.location.href = "/ceremonias";
  }

  //Nombre de la pestaña
  window.document.title = "Iniciar sesión";
  const [credenciales, setCredenciales] = useState({
    usuario: "",
    contrasena: "",
  });
  const [showAlert, setShowAlert] = useState(false);
  const [alertTxt, setAlertTxt] = useState("Usuario o contraseña incorrectos");
  const [login, setLogin] = useState(false);
  const [txtBtn, setTxtBtn] = useState("Iniciar sesión");

  const validarCampos = () => {
    if (credenciales.usuario === "" || credenciales.contrasena === "") {
      return false;
    }
    return true;
  };

  const iniciarSesion = async () => {
    setShowAlert(false);
    if (validarCampos()) {
      setLogin(true);
      setTxtBtn("Iniciando sesión...");

      // Aquí se debe hacer la petición al servidor
      const tk = await loginF(credenciales);

      if (tk) {
        //Validamos que el token tenga la propiedad token
        if (tk.token) {
          // Guardamos el token en localStorage
          localStorage.setItem("token", tk.token);

          window.location.href = "/inicio";
        } else {
          setAlertTxt("Usuario o contraseña incorrectos");
          setShowAlert(true);
        }
      } else {
        setAlertTxt("Error al conectar con el servidor.");
        setShowAlert(true);
      }
    } else {
      setAlertTxt("Faltan campos por llenar.");
      setShowAlert(true);
    }
    setLogin(false);
    setTxtBtn("Iniciar sesión");
  };

  //Listener para la tecla Enter
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      iniciarSesion();
    }
  };

  useEffect(() => {
    document.addEventListener("keypress", handleKeyPress);
    return () => {
      document.removeEventListener("keypress", handleKeyPress);
    };
  }, [credenciales]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f4f6f8",
      }}
    >
      <Container maxWidth="md" sx={{ my: 5 }}>
        <Card
          sx={{
            // Agrega sombra al card
            boxShadow: 5,
            borderRadius: 4,
            display: "flex",
            // height: "100%",
            margin: 10,
            marginBottom: 0,
            marginTop: 0,
          }}
        >
          <Grid container spacing={0}>
            {/* Imagen del lado izquierdo */}
            <Grid item xs={12} md={6}>
              <CardMedia
                component="img"
                // Imagen estática de la carpeta public
                src={imagenes("./sanEsteban/SanEsteban.jfif")}
                height="100%"
                alt="san esteban"
                sx={{
                  // Se imita la clase "rounded-start w-100"
                  borderTopLeftRadius: 4,
                  borderBottomLeftRadius: 4,
                  // width: "100%",
                  // height: "50%",
                  objectFit: "cover",
                }}
              />
            </Grid>

            {/* Formulario de login del lado derecho */}
            <Grid item xs={12} md={6}>
              <CardContent
                sx={{ display: "flex", flexDirection: "column", p: 3 }}
              >
                {/* Logo e ícono */}
                <Box
                  sx={{ display: "flex", alignItems: "center", mt: 2, mb: 2 }}
                >
                  <img
                    src={imagenes("./medalla/Medalla_transparente_roja.png")}
                    alt="medalla"
                    style={{ width: 40 }}
                  />
                  <Typography
                    variant="h6"
                    component="span"
                    sx={{
                      fontWeight: "bold",
                      ml: 3,
                      textTransform: "uppercase",
                    }}
                  >
                    Archicofradía de San Esteban
                  </Typography>
                </Box>
                {/* Título */}
                <Typography
                  variant="h5"
                  sx={{
                    mt: 7,
                    mb: 3,
                    // pb: 3,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  color="secondary.dark"
                >
                  Iniciar sesión
                </Typography>
                {/* Alerta de error */}
                {showAlert && (
                  <Alert
                    icon={<ErrorOutline fontSize="inherit" />}
                    severity="error"
                    sx={{ mb: 1 }}
                  >
                    {alertTxt}
                  </Alert>
                )}
                {/* Campos de entrada */}
                <TextField
                  fullWidth
                  margin="normal"
                  label="Usuario"
                  type="text"
                  value={credenciales.usuario}
                  onChange={(e) => {
                    setCredenciales({
                      ...credenciales,
                      usuario: e.target.value,
                    });
                  }}
                />
                <TextField
                  fullWidth
                  margin="normal"
                  label="Contraseña"
                  type="password"
                  value={credenciales.contrasena}
                  onChange={(e) => {
                    setCredenciales({
                      ...credenciales,
                      contrasena: e.target.value,
                    });
                  }}
                />
                {/* Botón de Login */}
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ mt: 3, mb: 2, px: 5 }}
                  onClick={iniciarSesion}
                  disabled={login}
                >
                  {txtBtn}
                </Button>
                {/* Enlaces */}
                <Box sx={{ textAlign: "center", mt: 6 }}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 1 }}
                  >
                    Capilla San Atanasio
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 1 }}
                  >
                    Guadalajara, Jal.
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Fraternidad Sacerdotal San Pío X
                  </Typography>
                </Box>
              </CardContent>
            </Grid>
          </Grid>
        </Card>
      </Container>
    </Box>
  );
};
